"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const _utils = require("~/utils");
const up = async (knex)=>{
    console.time('nc_074_missing_context_indexes');
    if (!_utils.isEE) {
        await knex.schema.alterTable(_globals.MetaTable.COL_BUTTON, (table)=>{
            table.string('fk_workspace_id', 20);
        });
    }
    await knex.schema.alterTable(_globals.MetaTable.COL_BUTTON, (table)=>{
        table.index('fk_column_id');
        table.index([
            'base_id',
            'fk_workspace_id'
        ], 'nc_col_button_context');
    });
    await knex.schema.alterTable(_globals.MetaTable.COL_LONG_TEXT, (table)=>{
        table.index([
            'base_id',
            'fk_workspace_id'
        ], 'nc_col_long_text_context');
    });
    await knex.schema.alterTable(_globals.MetaTable.DATA_REFLECTION, (table)=>{
        table.index('fk_workspace_id');
    });
    await knex.schema.alterTable(_globals.MetaTable.JOBS, (table)=>{
        table.index([
            'base_id',
            'fk_workspace_id'
        ], 'nc_jobs_context');
    });
    await knex.schema.alterTable(_globals.MetaTable.USERS, (table)=>{
        table.index('email');
    });
    console.timeEnd('nc_074_missing_context_indexes');
};
const down = async (knex)=>{
    if (!_utils.isEE) {
        await knex.schema.alterTable(_globals.MetaTable.COL_BUTTON, (table)=>{
            table.dropColumn('fk_workspace_id');
        });
    }
    await knex.schema.alterTable(_globals.MetaTable.COL_BUTTON, (table)=>{
        table.dropIndex('fk_column_id');
        table.dropIndex([
            'base_id',
            'fk_workspace_id'
        ], 'nc_col_button_context');
    });
    await knex.schema.alterTable(_globals.MetaTable.COL_LONG_TEXT, (table)=>{
        table.dropIndex([
            'base_id',
            'fk_workspace_id'
        ], 'nc_col_long_text_context');
    });
    await knex.schema.alterTable(_globals.MetaTable.DATA_REFLECTION, (table)=>{
        table.dropIndex('fk_workspace_id');
    });
    await knex.schema.alterTable(_globals.MetaTable.JOBS, (table)=>{
        table.dropIndex([
            'base_id',
            'fk_workspace_id'
        ], 'nc_jobs_context');
    });
    await knex.schema.alterTable(_globals.MetaTable.USERS, (table)=>{
        table.dropIndex('email');
    });
};
